import styled from 'styled-components';

export const Container = styled.div`
    border: 1px solid ${(props) => props.theme.grey_16_tr};
    box-shadow: ${(props) => props.theme.shadow_grey};
    border-radius: 12px;
    padding: 16px 20px 16px 22px;
    display: flex;
    align-items: center;
    margin-bottom: 48px;
    cursor: pointer;
    justify-content: space-between;
`;

export const IconWrapper = styled.div`
    flex-shrink: 0;
    margin-left: 20px;
`;
